import React from 'react'
import CompanyCard from '../../components/BugBounty/Company'

const CompanyPage = () => {
  return (
    <div>
        <CompanyCard></CompanyCard>
    </div>
  )
}

export default CompanyPage